<template>
  <div class="home" :class="{ 'touch-layout': isTouchVersion }">
    <div>
      <header :class="{ 'vertical-nav': isTouchVersion }">
        <img class="logo" src="../assets/logo.png" :alt="$t('nav.home')" />
        <div class="navMenu">
          <ul>
            <li v-for="(item, index) in nav_datas" :key="index" :class="{ move: currentIndex === index }"
              @click="goTo(item, index)">
              {{ item.name }}
            </li>
          </ul>
        </div>
        <div class="right">
          <span class="hotline">{{ $t('contact.phone') }}&nbsp;:&nbsp;0714-3869888</span>
          <div class="buyTicket">
            <el-button type="success" size="medium" @click="goBuyTicket">{{ $t('home.buyTicket') }}</el-button>
            <language-switch class="lang-switch" />
          </div>
        </div>
      </header>
      <!-- Banner section has been hidden as per user request -->
      <main>
        <div class="main-content" v-show="!isShow">
          <!-- 三个景区卡片 -->
          <div class="attraction-cards">
            <div class="card" @click="playVideo">
              <img src="@/assets/home_banner1.jpg" alt="太空旅行" />
              <div class="play-button">
                <div class="play-icon"></div>
              </div>
            </div>
            <div class="card water-card" @click="goToScenic('water')">
              <img src="@/assets/DinosaurWaterWorld.jpg" alt="恐龙水世界" />
              <!-- <div class="card-overlay">
                <h3>恐龙水世界</h3>
              </div> -->
            </div>
            <div class="card" @click="goToScenic('land')">
              <img src="@/assets/DinosaurLandWorld.jpg" alt="恐龙梦工厂" />
              <!-- <div class="card-overlay">
                <h3>恐龙梦工厂</h3>
              </div> -->
            </div>
          </div>

          <!-- 景区动态和新闻资讯 -->
          <div class="news-section">
            <div class="news-column">
              <h2 class="section-title">{{ $t('news.parkDynamics') }}</h2>
              <div class="news-scroll-container">
                <ul class="news-list" ref="newsScrollList">
                  <li v-for="(item, index) in parkDynamicsItems" :key="index">
                    <span class="news-dot">●</span>
                    <a :href="item.url" target="_blank" class="news-text">{{ item.title }}</a>
                    <span class="news-date">{{ item.date }}</span>
                  </li>
                </ul>
              </div>
            </div>
            <div class="news-column">
              <h2 class="section-title">{{ $t('news.newsInfo') }}</h2>
              <div class="news-scroll-container">
                <ul class="news-list" ref="newsInfoList">
                  <li v-for="(item, index) in newsInfoItems" :key="index">
                    <span class="news-dot">●</span>
                    <a :href="item.url" target="_blank" class="news-text">{{ item.title }}</a>
                    <span class="news-date">{{ item.date }}</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div v-show="isShow">
          <keep-alive>
            <component :is="currentView" ref="usComponent" />
          </keep-alive>
        </div>
      </main>
      <footer>
        <div class="footerLeft">
          <div class="qrcode">
            <img src="@/assets/vr.jpg" :alt="$t('home.vr')" @click="openVRPanorama" style="cursor: pointer;" />
            <div>{{ $t('home.vr') }}</div>
          </div>
          <div class="qrcode">
            <img src="@/assets/red.png" :alt="$t('home.scanXiaohongshu')" />
            <div>{{ $t('home.scanXiaohongshu') }}</div>
          </div>
          <div class="qrcode">
            <img src="@/assets/public.jpg" :alt="$t('home.scanWechat')" />
            <div>{{ $t('home.scanWechat') }}</div>
          </div>
          <div class="qrcode">
            <img src="@/assets/weibo.png" :alt="$t('home.scanWeibo')" />
            <div>{{ $t('home.scanWeibo') }}</div>
          </div>
          <div class="qrcode">
            <img src="@/assets/douyin.png" :alt="$t('home.scanDouyin')" />
            <div>{{ $t('home.scanDouyin') }}</div>
          </div>
        </div>
        <div class="footerRight">
          <div class="footerInfo">
            <div>{{ $t('us.businessHours') }}</div>
            <div v-html="$t('us.openingHours')"></div>
            <div class="a">{{ $t('us.hotline') }}: 0714-3869888</div>
            <div>{{ $t('us.address') }}</div>
            <a href="https://beian.miit.gov.cn/" style="textDecoration: none;color:#FFF;">备案号：鄂ICP备2021014446号</a>
          </div>
        </div>
      </footer>
    </div>
    <div v-if="isVideo">
      <!-- 遮罩层 -->
      <div class="mask">
      </div>
      <div class="video">
        <video width="1000" height="600" autoplay class="v-player" muted controls>
          <source src="@/assets/home/home.mp4" type="video/mp4">
        </video>
        <img src="../assets/closed_icon.png" alt="Close" @click="isVideo = false">
      </div>
    </div>
    <el-dialog :visible.sync="closedialogVisible" width="50%" :close-on-click-modal="false" center title="关于运营时间调整的公告">
      <div style="line-height: 30px; font-size: 16px">
        <p>闭园日期及营业时间调整通知</p>
        <p>金秋来临，天气渐凉，水温也逐渐下降。为了确保游客的身体健康，黄石卡乐星球·恐龙水世界对闭园日期及营业时间作出以下调整：</p>
        <p>1、闭园日期：2022年9月13日（暂定，如有疫情或重大变化另行通知）</p>
        <p>2、现行开园时间：即日起至2022年9月12日</p>
        <p>3、2022年8月29日—9月12日营业时间：11：00—19：00</p>
        <p style="text-align: right">黄石卡乐星球·恐龙水世界</p>
        <p style="text-align: right">2022年8月26日</p>
      </div>
    </el-dialog>
  </div>
</template>

<script>
// @ is an alias to /src
//缤纷景区
import Scenic from './Scenic'
//关于我们
import Us from './Us'
//扫码购票
import Qrcode from './Qrcode'
//景区导览
import Daolan from './Daolan'
//投诉建议
import Contact from './Contact'
import LanguageSwitch from '@/components/LanguageSwitch'
export default {
  name: 'Home',
  props: {
    isTouchVersion: {
      type: Boolean,
      default: false
    }
  },
  components: {
    Scenic,
    Us,
    Qrcode,
    Daolan,
    Contact,
    LanguageSwitch
  },
  data() {
    return {
      isVideo: false,
      closedialogVisible: false,
      isShow: false,
      isQrcode: false,
      currentIndex: 0,
      currentView: '',
      currentNewsIndex: 0,
      bannerList: [
        { url: require('@/assets/home_banner1.jpg'), clickable: true },
        { url: require('@/assets/home_banner2.jpg'), clickable: false },
        { url: require('@/assets/home_banner3.jpg'), clickable: false },
        { url: require('@/assets/home_banner4.jpg'), clickable: false },
        { url: require('@/assets/home_banner5.jpg'), clickable: false },
      ],
      timer: null,
      lastTime: null,
      scrollTimer: null,
    }
  },
  computed: {
    nav_datas() {
      return [
        { name: this.$t('nav.home'), view: 'home' },
        { name: this.$t('nav.scenic'), view: 'scenic' },
        { name: this.$t('nav.about'), view: 'us' },
        { name: this.$t('nav.guide'), view: 'daolan' },
        { name: this.$t('nav.contact'), view: 'contact' },
      ]
    },
    parkDynamicsItems() {
      return this.$t('news.parkDynamicsItems').map((item, index) => ({
        ...item,
        url: this.getDynamicsUrl(index)
      }));
    },
    newsInfoItems() {
      return this.$t('news.newsInfoItems').map((item, index) => ({
        ...item,
        url: this.getNewsInfoUrl(index)
      }));
    }
  },
  methods: {
    // 获取景区动态链接
    getDynamicsUrl(index) {
      const urls = [
        'https://mp.weixin.qq.com/s/eBoJRXNlDTeDBYjjzbPcbw',
        'https://mp.weixin.qq.com/s/lnWHqxW4fOr9CVEr27F2dw',
        'https://mp.weixin.qq.com/s/c3BcO53NGsj1zUqZ6_AEMg',
        'https://mp.weixin.qq.com/s/VtNvELmZIgo875yd-2BSuQ',
        'https://mp.weixin.qq.com/s/kNPrLT0OJ_vL3fOVQocWnw',
        'https://mp.weixin.qq.com/s/U3IruFXeDDCjzg7sled95g',
        'https://mp.weixin.qq.com/s/jaip12o2YlawkIcT5MnfUg',
        'https://mp.weixin.qq.com/s/vgsbFGoqCJhSzlu1PbV37Q'
      ];
      return urls[index] || '#';
    },
    // 获取新闻资讯链接
    getNewsInfoUrl(index) {
      const urls = [
        'https://mp.weixin.qq.com/s/xiurtvHGuNyGnQo-Q-iigg',
        'https://mp.weixin.qq.com/s/CDIij7p8ImIgb_0ddI8cHw',
        'https://mp.weixin.qq.com/s/mWGoolTHzKeEQfu1esWifg',
        'https://mp.weixin.qq.com/s/XCIcRUVhXMg7eqHwi4KblA',
        'https://mp.weixin.qq.com/s/EzZmau6Vfh3dVdBOUf7xcw',
        'https://mp.weixin.qq.com/s/dDLePa0S6S5zb9zfnZZJeA',
        'https://mp.weixin.qq.com/s/8VpkYhwE6g5Tesz2RSH4Sg',
        'https://mp.weixin.qq.com/s/g93hbruC9Nq1VKaOgSkFBQ',
        'https://mp.weixin.qq.com/s/QfG33WuISZuSNzW7dTzeQg',
        'https://mp.weixin.qq.com/s/ZxU9C9yAAzGyLiIxnHIBvA',
        'https://mp.weixin.qq.com/s/fVZPBsg0mJfmzuxzkkdEUA',
        'https://mp.weixin.qq.com/s/-u42RCwOaU-2B_-YE1uDpg',
        'https://mp.weixin.qq.com/s/76e4YuvBPllugPYcAqyc6w',
        'https://mp.weixin.qq.com/s/M5wSeBRw5KB65lgC5-8Gog',
        'https://mp.weixin.qq.com/s/dol5tEF94DxdI7_RqQfzkQ',
        'https://mp.weixin.qq.com/s/lfbbyOTvKqPbYcxUooCs-Q'
      ];
      return urls[index] || '#';
    },
    // 不再需要JavaScript控制滚动，使用CSS动画实现
    startNewsScroll() {
      // 已通过CSS animation实现自动滚动
    },
    /** 在线购票 */
    goBuyTicket() {
      this.currentView = 'Qrcode'
      this.isShow = true
      this.currentIndex = 5
    },
    /** 水乐园 */
    goToScenic(val) {
      if (val == 'water') {
        this.isShow = true
        this.currentView = 'Scenic'
        this.currentIndex = 1
        // 缓存事件，等待 Scenic.vue 创建后触发
        this.$nextTick(() => {
          this.$emit('scroll-to-item', { index: 22 });
        });
      } else if (val == 'land') {
        this.isShow = true
        this.currentView = 'Scenic'
        this.currentIndex = 1
        // 缓存事件，等待 Scenic.vue 创建后触发
        this.$nextTick(() => {
          this.$emit('scroll-to-item', { index: 0 });
        });
      }
    },
    /** 播放视频 */
    playVideo() {
      this.isVideo = true;
    },
    /** 导航栏点击 */
    goTo(item, index) {
      this.currentIndex = index
      switch (item.view) {
        case 'home':
          this.currentView = ''
          this.isShow = false
          break
        case 'scenic':
          this.isShow = true
          this.currentView = 'Scenic'
          break
        case 'us':
          this.isShow = true
          this.currentView = 'us'
          break
        case 'daolan':
          this.isShow = true
          this.currentView = 'daolan'
          break
        case 'contact':
          this.isShow = true
          this.currentView = 'contact'
          break
      }
    },
    handleBannerClick(index) {
      if (this.bannerList[index].clickable) {
        // 设置为"关于我们"页面
        this.isShow = true
        this.currentView = 'Us'
        this.currentIndex = 2
        
        // 等待组件加载完毕后调用其跳转到精彩活动的方法
        this.$nextTick(() => {
          const usComponent = this.$refs.usComponent
          if (usComponent && typeof usComponent.scrollToSpecialEvents === 'function') {
            usComponent.scrollToSpecialEvents()
          }
        })
      }
    },
    /** VR全景跳转 */
    openVRPanorama() {
      window.open('http://106.15.207.28:88/hsklg_vr/', '_blank')
    },
  },
  mounted() {
    //这里的数字可以换成 0~this.nav_datas.length 之间任意的数字
    this.nav_datas[0].class_true = true
    // 启动新闻滚动
    this.startNewsScroll()
  },
  beforeDestroy() {
    // 不再需要清除定时器
  },
}
</script>
<style lang="less" scoped>
.home {
  width: 100%;
  height: 100%;
  position: relative;

  &.touch-layout {
    .banner {
      margin-left: 15vw;
      width: calc(100% - 15vw);
    }
    
    main {
      margin-left: 15vw;
      width: calc(100% - 15vw);
      padding-top: 0; /* 移除顶部内边距 */
    }
    
    footer {
      margin-left: 15vw;
      width: calc(100% - 15vw);
    }
  }

  .mask {
    width: 100%;
    height: 100%;
    background: #000;
    opacity: 0.5;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 999;
  }
  .video {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 9999;
    .v-player {
      object-fit: fill;
    }
    img {
      position: absolute;
      top: -2.08vw; /* -40px at 1920px */
      right: -2.08vw; /* -40px at 1920px */
      cursor: pointer;
    }
  }
  
  .main-content {
    padding: 2vw 2vw;
    padding-top: 6.53vw; /* 添加顶部间距避免被header遮挡，header高度4.53vw + 额外间距2vw */
    background-color: #f5f5f5;
  }

  .attraction-cards {
    display: flex;
    justify-content: space-between;
    margin-bottom: 2vw;
    gap: 2vw; /* 添加卡片之间的间隔 */

    .card {
      position: relative;
      overflow: hidden;
      border-radius: 1vw;
      box-shadow: 0 0.5vw 1vw rgba(0, 0, 0, 0.1);
      cursor: pointer;
      transition: transform 0.3s ease;

      &:hover {
        transform: scale(1.05);
      }

      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }

      &:first-child {
        width: calc(42.86% - 1.33vw); /* 调整宽度以适应间隔 */
      }

      &:not(:first-child) {
        width: calc(28.57% - 1.33vw); /* 调整宽度以适应间隔 */
      }

      .play-button {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 5vw;
        height: 5vw;
        background-color: rgba(255, 255, 255, 0.9);
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        transition: all 0.3s ease;

        &:hover {
          background-color: rgba(255, 255, 255, 1);
          transform: translate(-50%, -50%) scale(1.1);
        }

        .play-icon {
          width: 0;
          height: 0;
          border-style: solid;
          border-width: 1.2vw 0 1.2vw 2vw;
          border-color: transparent transparent transparent #333;
          margin-left: 0.3vw;
        }
      }

      .card-overlay {
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
        background: rgba(0, 0, 0, 0.5);
        color: white;
        padding: 1vw;
        text-align: center;

        h3 {
          margin: 0;
          font-size: 1.5vw;
        }
      }
    }
  }

  .news-section {
    display: flex;
    justify-content: space-between;

    .news-column {
      width: 48%;
      background: white;
      border-radius: 1vw;
      padding: 1.5vw;
      box-shadow: 0 0.5vw 1vw rgba(0, 0, 0, 0.1);

      .section-title {
        font-size: 1.2vw;
        color: #333;
        margin-bottom: 1vw;
        padding-bottom: 0.5vw;
        border-bottom: 0.2vw solid #85b62c;
        text-align: left;
      }

      .news-scroll-container {
        height: 10vw; /* 固定高度，显示4条新闻 */
        overflow: hidden;
        position: relative;
      }

      .news-list {
        list-style-type: none;
        padding: 0;
        position: absolute;
        width: 100%;
        animation: scrollNews 24s linear infinite; /* 8条新闻，每条3秒 */

        &:hover {
          animation-play-state: paused; /* 鼠标悬停时暂停滚动 */
        }

        li {
          display: flex;
          align-items: center;
          padding: 0.6vw 0;
          font-size: 1vw;
          height: 2.5vw; /* 每条新闻固定高度 */

          .news-dot {
            color: #85b62c;
            margin-right: 0.5vw;
            flex-shrink: 0;
            font-size: 30px;
          }

          .news-text {
            flex-grow: 1;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            text-align: left;
            color: #333;
            text-decoration: none;
            transition: color 0.2s;
            
            &:hover {
              color: #85b62c;
            }
          }

          .news-date {
            color: #999;
            font-size: 0.9vw;
            flex-shrink: 0;
            margin-left: 1vw;
          }
        }
      }
    }
  }
  header {
    position: fixed;
    top: 0;
    left: 0;
    height: 4.53vw; /* 87px at 1920px */
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    color: #fff;
    z-index: 99;
    background: linear-gradient(to right, #85b62c, #9cc949);
    transition: all 0.3s ease;

    &.vertical-nav {
      width: 15vw;
      height: 100vh;
      flex-direction: column;
      justify-content: space-between;
      padding: 2vw 0;
      background: linear-gradient(to bottom, #85b62c, #9cc949);
    }

    .logo {
      height: 4.5vw; /* 86px at 1920px */
      width: 4.5vw; /* 86px at 1920px */
      margin-left: 1.04vw; /* 20px at 1920px */
    }

    &.vertical-nav .logo {
      margin-left: 0;
      margin-bottom: 2vw;
      height: 5vw; /* 96px at 1920px */
      width: 5vw; /* 96px at 1920px */
    }

    .navMenu {
      font-size: 0.94vw; /* 18px at 1920px */
      letter-spacing: 0.21vw; /* 4px at 1920px */
      height: 4.27vw; /* 82px at 1920px */
      line-height: 4.27vw; /* 82px at 1920px */
      ul {
        list-style-type: none;
        padding: 0px;
        float: right;
        position: relative;
        /*子元素absol*/
        li {
          width: 8.33vw; /* 160px at 1920px */
          text-align: center;
          float: left;
          cursor: pointer;
          position: relative;
          transition: all 0.3s ease;

          &:hover, &.move {
            background-color: rgba(255, 255, 255, 0.2);
          }

          &.move::after {
            content: '';
            position: absolute;
            bottom: 0;
            left: 0;
            width: 100%;
            height: 3px;
            background-color: #fff;
          }
        }
      }

      
    }

    &.vertical-nav .navMenu {
      width: 100%;
      height: auto;
      margin-right: 0;
      
      ul {
        float: none;
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        
        li {
          width: 100%;
          padding: 1vw 0;
          float: none;
          margin-bottom: 1vw;
          font-weight: bold;
          border-radius: 0.52vw;
          transition: background-color 0.3s;
          
          &:hover {
            background-color: rgba(255, 255, 255, 0.2);
          }
        }
        
        .move {
          background: rgba(255, 255, 255, 0.3);
          
          &::before {
            display: none;
          }
        }
      }

      .move {
        font-weight: bold;
        color: #fff;
        background: rgba(255, 255, 255, 0.3);
        position: relative;
        &::before {
          display: block;
          content: ' ';
          background-color: #fff;
          height: 0.21vw; /* 4px at 1920px */
          width: 100%;
          position: absolute;
          bottom: -0.1vw; /* -2px at 1920px */
          left: 0px;
        }
      }
    }
    .right {
      font-size: 0.73vw; /* 14px at 1920px */
      color: #7e7e7e;
      display: flex;
      align-items: center;
      margin-right: 2vw; /* 增加右边空白 */
      .date {
        padding-right: 0.42vw; /* 8px at 1920px */
        border-right: 0.1vw solid #ccc; /* 2px at 1920px */
      }
      .hotline {
        color: #ffffff;
        margin-right: 1vw; /* 电话号码右边留空白 */
      }
    }

    &.vertical-nav .right {
      flex-direction: column;
      align-items: center;
      padding: 1vw;
      margin-top: auto;
      background: rgba(255, 255, 255, 0.1);
      border-radius: 0.5vw;

      .hotline {
        margin: 0.5vw 0;
        font-size: 0.8vw;
      }

      .buyTicket {
        display: flex;
        flex-direction: column;
        align-items: center;

        .el-button {
          margin-bottom: 0.5vw;
          font-size: 0.8vw;
          padding: 0.5vw 1vw;
        }

        .lang-switch {
          margin-left: 0;
          margin-top: 0.5vw;
        }
      }
    }
    .buyTicket {
      padding-left: 0.89vw; /* 17px at 1920px */
      display: flex;
      align-items: center;
      margin-right: 1vw; /* 购票区域右边留空白 */
      .lang-switch {
        margin-left: 0.89vw;
        margin-right: 0.5vw; /* 语言切换右边留空白 */
      }
    }

    &.vertical-nav .navMenu {
      flex: 1;
      overflow-y: auto;
      margin: 0.5vw 0;

      &::-webkit-scrollbar {
        width: 0.2vw;
      }

      &::-webkit-scrollbar-thumb {
        background-color: rgba(255, 255, 255, 0.3);
        border-radius: 0.1vw;
      }

      &::-webkit-scrollbar-track {
        background-color: rgba(0, 0, 0, 0.1);
      }

      ul {
        li {
          padding: 0.5vw 0;
          margin-bottom: 0.3vw;
          font-size: 0.85vw;
        }
      }
    }
  }
  /* Banner styles have been removed as the banner is now hidden */
  main {
    display: flex;
    justify-content: center;
    .main {
      margin-top: 4.53vw; /* 87px at 1920px */
      padding: 1.56vw 0; /* 30px at 1920px */

      .touch-layout & {
        margin-top: 0; /* 触屏版时移除顶部外边距 */
      }
      width: 62.5vw; /* 1200px at 1920px */
      display: flex;
      align-items: center;
      justify-content: center;
      img {
        border-radius: 1.04vw; /* 20px at 1920px */
        width: 30.21vw; /* 580px at 1920px */
        height: 12.5vw; /* 240px at 1920px */
        cursor: pointer;
      }
    }
  }
  footer {
    width: 100%;
    height: 13.02vw; /* 250px at 1920px */
    background: #85b62c;
    display: flex;
    align-items: center;
    font-size: 0.73vw; /* 14px at 1920px */
    transition: all 0.3s ease;

    .home.touch-layout & {
      flex-direction: column;
      height: auto;
      padding: 2vw 0;
    }
    .footerLeft {
      height: 9.38vw; /* 180px at 1920px */
      padding-right: 3.91vw; /* 75px at 1920px */
      width: 50%;
      border-right: 0.1vw solid #fff; /* 2px at 1920px */
      display: flex;
      align-items: center;
      justify-content: flex-end;

      .home.touch-layout & {
        width: 100%;
        border-right: none;
        border-bottom: 0.1vw solid #fff;
        padding-right: 0;
        padding-bottom: 2vw;
        justify-content: center;
      }
      .footerlogo {
        width: 6.77vw; /* 130px at 1920px */
        height: 6.77vw; /* 130px at 1920px */
        margin-right: 1.04vw; /* 20px at 1920px */
        img {
          width: 6.77vw; /* 130px at 1920px */
          height: 6.77vw; /* 130px at 1920px */
        }
      }
      .qrcode {
        color: #ffffff;
        img {
          width: 6.25vw; /* 120px at 1920px */
          height: 6.25vw; /* 120px at 1920px */
          margin: 0 1.04vw; /* 20px at 1920px */
        }
        div {
          padding-top: 0.26vw; /* 5px at 1920px */
        }
      }
    }
    .footerRight {
      width: 50%;
      padding-left: 3.91vw; /* 75px at 1920px */
      height: 13.02vw; /* 250px at 1920px */
      color: #fff;
      text-align: left;
      display: flex;
      align-items: center;
      justify-content: flex-start;

      .home.touch-layout & {
        width: 100%;
        padding-left: 0;
        padding-top: 2vw;
        height: auto;
        justify-content: center;
      }
      .footerInfo {
        div {
          // padding-bottom: 0.26vw; /* 5px at 1920px */
        }
        .a {
          margin-top: 0.78vw; /* 15px at 1920px */
        }
      }
    }
  }
  /deep/ .el-carousel__arrow {
    background: #fff !important;
    opacity: 0.5;
    color: green;
    width: 4.69vw; /* 90px at 1920px */
    height: 4.69vw; /* 90px at 1920px */
    font-size: 1.04vw; /* 20px at 1920px */
    &:hover {
      opacity: 0.75;
    }
  }
  /deep/ .el-carousel__container {
    height: 41.15vw; /* 790px at 1920px */
    width: 100%;
  }
  /deep/ .el-button--success {
    background: #85b62c;
  }
}
@keyframes scrollNews {
  0% {
    transform: translateY(0);
  }
  100% {
    transform: translateY(-100%); /* 滚动整个列表高度 */
  }
}
</style>
